<template>
  <div id="survey-overview">
  <div class="row">
      <div class="col s12">
        <div class="title-area">Water Shortage Hazard Assessment</div>
        <div class="col s12">
          What would you do if you lost WASCO water supply for a 2-week period after a disaster event? Could your household still meet its water needs? Use this fun water demand calculator to find out how much water your household uses in a 2-week period and determine if you have enough water storage capacity to meet your needs without WASCO’s water supply.
        </div>
      </div>
    </div>
    <div class="row flex wrap-items">
      <div class="col s6" v-for="(tool, index) in tools" :key="index">
        <div class="card hoverable">
          <div class="card-content">
             <div class="icon-area" v-if="tool.icon">
              <img @click="$_goToStep(tool.toIndex, tool.toStep)" :src="tool.icon">
            </div>
            <span  @click="$_goToStep(tool.toIndex, tool.toStep)" style="cursor:pointer" class="card-title indigo-text text-accent-5">
              {{tool.name}}
            </span>
          </div>
          <div class="action-container">
            <div class="card-action">
              <button
                class="btn btn-rounded indigo accent-5 waves-effect"
                @click="$_goToStep(tool.toIndex, tool.toStep)"
              >
                <span v-if="tool.toStep === 'indoor'"> {{ indoorStatusX }} </span>
                <span v-else-if="tool.toStep === 'water'"> {{ waterStatusX }} </span>
                <span v-else>Review</span>
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
<!--     <div class="card">
      <div class="card-content">
        <span class="card-title">
          Indoor household water demand calculator
        </span>
        <p></p>
      </div>
      <div class="card-action">
        <button
          class="btn btn-flat waves-effect waves-back white green-text"
          @click="$_goToStep(1, 'indoor')"
        >
          {{ indoorStatusX }}
        </button>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <span class="card-title">
          Water shortage resiliency measures present
        </span>
        <p></p>
      </div>
      <div class="card-action">
        <button
          class="btn btn-flat waves-effect waves-back white green-text"
          @click="$_goToStep(2, 'water')"
        >
          {{ waterStatusX }}
        </button>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <span class="card-title">
          Overview
        </span>
        <p></p>
      </div>
      <div class="card-action">
        <button
          class="btn btn-flat waves-effect waves-back white green-text"
          @click="$_goToStep(3, '')"
        >
          View
        </button>
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import water_tank_storage from '@/assets/water_tank_storage.svg'
import water_shortage from '@/assets/water_calculator.svg'
import overview_icon from '@/assets/overview_icon.svg'
import water_tank from '@/assets/water_tank.svg'
export default {
  name: 'SurveyOverview',
  props: {},
  data () {
    return {
        tools:[
        {
          icon: water_shortage,
          name: 'Indoor Household Water Demand Calculator',
          buttonText: 'Start',
          toIndex: 1,
          toStep: 'indoor'
        },
        {
          icon: water_tank,
          name: 'Water Shortage Resiliency Measures Present',
          buttonText: 'Start',
          toIndex: 2,
          toStep: 'water'
        },
          {
          icon: water_tank_storage,
          name: 'Summary of Two-Week Water Demand versus Water Storage Capacity',
          buttonText: 'Start',
          toIndex: 3,
          toStep: 'summary'
        },
        {
          icon: overview_icon,
          name: 'Expected Impact Level',
          buttonText: 'Start',
          toIndex: 4,
          toStep: 'overview'
        },

      ]
    }
  },
  mounted() {},
  computed: {
    ...mapState({
      waterHazard: (state) => state.Surveys.waterHazard,
    }),

    indoorStatusX() {
      if (this.waterHazard && this.waterHazard.survey) {
        return !!this.waterHazard.survey["grandTotal"] ? "Continue" : "Begin";
      }
      return "Begin";
    },

    waterStatusX() {
      if (this.waterHazard && this.waterHazard.survey) {
        return this.waterHazard.survey["water_resiliency_features"].length > 0
          ? "Continue"
          : "Begin";
      }
      return "Begin";
    },
  },
  methods: {
    ...mapActions("Helpers", ["setHelper"]),
    $_goToStep(step, section) {
    //  this.$router.push({query:{editing:true}})
      this.$router.push({query:{editing:true, section:step, step:step}})
      this.$emit("updateStep", { step, section });
      

      try {
        let oldHistory = localStorage.getItem('stepHistory')
        if(oldHistory) {
          let newBlock = JSON.parse(oldHistory)
          let blankObject = {...newBlock}
          blankObject[this.$route.name.toLowerCase()] =  {
                route:this.$route.name,
                step: step,
                timeStamp: new Date()
              }
          localStorage.setItem('stepHistory',JSON.stringify(blankObject))

        } else {
             let newBlock = {}
          let blankObject = {...newBlock}
          blankObject[this.$route.name.toLowerCase()] =  {
                route:this.$route.name,
                step: step,
                timeStamp: new Date()
              }
          localStorage.setItem('stepHistory',JSON.stringify(blankObject))
        }
      } catch (error) {
        let newBlock = {}
          let blankObject = {...newBlock}
          blankObject[this.$route.name.toLowerCase()] =  {
                route:this.$route.name,
                step: step,
                timeStamp: new Date()
              }
          localStorage.setItem('stepHistory',JSON.stringify(blankObject))
        return error
      }

    },
  },
};
</script>
<style scoped lang="scss">
#survey-overview {
  padding: 16px;
  max-width: 768px; margin: auto;
  .card {
    height: calc(100% - 1.5rem);
      .card-title {
        font-size: 17px;
        font-weight: 500;
        line-height: 20.5px;
        margin-top: 4px;
        margin-bottom: 4px;
      }
      .action-container {
        height: 58px;
        width: 100%;
        .card-action {
            padding-top: 0px;
            position: absolute;
            bottom: 0; left: 0; right: 0;
            border: none;
            width: 100%;
            button {
              width: 100%;
            }
          }
      }
  }
  .title-area {
    font-size: 26px;
    margin: 22px 8px 2px;
    position: relative;
  }
  .icon-area {
    img {
      cursor: pointer;
      height: 75px;
    }
    margin-bottom: 12px;
  }
}
</style>
